"use strict";

import initModulesInScope from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import 'url-search-params-polyfill'; // Edge Polyfill
import {isParsleyForm, isValid, loadParsley} from "@elements/parsley-bootstrap-validation";

export function initInScope($scope) {
    let $form = $scope.find('.js-file-upload__form');

    $scope.find('.js-file-upload').each(function () {
        let $container = $(this);
        let $form = $container.find('.js-file-upload__form').length ? $container.find('.js-file-upload__form') : $container.closest('form');
        let $loading = $container.find('.js-file-upload__loading');
        let $input = $container.find('.js-file-upload__input');
        let $fileResult = $container.find('.js-file-upload__file-result');
        let $error = $container.find('.js-file-upload__error');
        let $submitBtn = $form.find('.js-file-upload__submit');
        let initialMaxFileNumber = +$input.data('parsley-max-file-upload');
        let addedFiles = [];

        // ************************ Drag and drop ***************** //
        let $dropArea = $container.find('.js-file-upload__drop-area');
        let dropArea = $dropArea[0];

        // Prevent default drag behaviors
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false);
            document.body.addEventListener(eventName, preventDefaults, false);
        });

        // Highlight drop area when item is dragged over it
        ['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(eventName, highlight, false);
        });

        ['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, unhighlight, false);
        });

        // Handle dropped files
        dropArea.addEventListener('drop', handleDrop, false);


        function preventDefaults(evt) {
            evt.preventDefault();
            evt.stopPropagation();
        }

        function highlight() {
            $dropArea.addClass('file-drop-area--highlight');
        }

        function unhighlight() {
            $dropArea.removeClass('file-drop-area--highlight');
        }

        function handleDrop(evt) {
            $input[0].files = getUpdatedFileList(addedFiles, evt.dataTransfer.files);

            // $input.trigger('change');
            updateFileUpload($input, $input[0].files, $fileResult, $error, $submitBtn, $dropArea, initialMaxFileNumber, $form, addedFiles);
        }

        // ************************ END***************** //

        $input.on('change', function (evt) {
            this.files = getUpdatedFileList(addedFiles, this.files);

            updateFileUpload($(this), this.files, $fileResult, $error, $submitBtn, $dropArea, initialMaxFileNumber, $form, addedFiles);
        });

        $scope.find('.js-file-upload__checkbox-image-input').on('change', function (e) {
            if($(this).is(':checked')){
                $(this).closest('.js-file-upload__checkbox-image').addClass('has-remove');
            }else{
                $(this).closest('.js-file-upload__checkbox-image').removeClass('has-remove');
            }
        });


        loadParsley().then(function () {
            window.Parsley.addValidator('requiredFileInput', {
                validateString: function (_value, requiredFileInput, parsleyInstance) {
                    let fileLength = $(parsleyInstance.$element).data('parsley-file-length');
                    return fileLength > 0;
                },
                messages: {
                    de: translate('file-upload.pflichtfeld'),
                    en: translate('file-upload.pflichtfeld')
                }
            });
        });

    });


    $form.each(function () {
        let formAction = $(this).attr('action');
        let $submitBtn = $form.find('button[type="submit"], button:not([type])');
        let $loading = $form.find('.js-file-upload__loading');
        let ignoreValidation = false;

        // If the clicked button has a formaction then this action will be use for the request
        $submitBtn.on('click', function (e) {
            if($(this).attr('formaction')){
                formAction = $(this).attr('formaction');
            }else{
                formAction = $form.data('action') || $form.attr('action') || window.location.href;
            }

            if($(this).data('form-ignore-validation')){
                ignoreValidation = true;
            }
        });

        $(this).on('submit', function(evt) {
            evt.preventDefault();
            $form = $(this);
            let form = this;
            let $input = $('.js-file-upload__input');
            let $error = $('.js-file-upload__form-error');
            let pendingRequest = null;

            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            if (!ignoreValidation && isParsleyForm($form) && !isValid($form)) {
                return;
            }

            $loading.prop('hidden', false);
            let formData = new FormData(form);

            $input.each(function (e) {
                let inputName = $(this).data('name'),
                    fileList = this.files;

                if(fileList){
                    Array.from(fileList).forEach(file => {
                        formData.append(inputName,file);
                    });
                }


            });

            pendingRequest = $.ajax(formAction, {
                method: 'POST',
                data: formData,
                type: 'POST',
                contentType: false,
                processData:false,
                enctype: 'multipart/form-data',
                headers: {Ajax: 1},
                dataType: 'json'
            }).done(function (result) {
                if(result.success && result.successUrl !== 'undefined') {
                    window.location.href = result.successUrl;
                    if(window.location.hash) {
                        window.location.reload();
                    }
                } else {
                    let errorIds = result.errorIds;

                    if(errorIds !== undefined){
                        for(let i=0; i<errorIds.length;i++){
                            let $inputErrorId = $('#' + errorIds[i]);

                            // remove existing error message
                            $inputErrorId.parsley().removeError('forcederror', {message: result.errorText, updateClass: true});

                            // add new error message
                            $inputErrorId.parsley().addError('forcederror', {message: result.errorText, updateClass: true});
                            $inputErrorId.removeClass('is-valid');

                            // remove error message when user types in input
                            $inputErrorId.on('change focus keypress', function (e) {
                                $('#' + errorIds[i]).parsley().removeError('forcederror', {message: result.errorText, updateClass: true});
                            });

                        }
                    }

                    $error.html(result.errorText);
                    $error.attr('hidden', null);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                if (textStatus !== 'abort') {
                    console.error(textStatus, errorThrown, jqXHR);
                    $error.attr('hidden', null);
                }
            }).always(function () {
                $loading.attr('hidden', 'hidden');
                pendingRequest = null;
            });

        });
    });

}


function removeItem($item, fileList, $error, $dropArea, addedFiles) {
    let $itemToRemove = $item.closest('.js-file-upload__item');
    // the reference to this file is saved in data-file
    let itemToRemoveRef = $itemToRemove.data('file');
    // check reference if this is the right file to be removed

    const newFileList = Object.values(fileList).filter(file => file.name !== itemToRemoveRef.name)
    let targetFileIndex = addedFiles.findIndex(function (file) {
        return file.name === itemToRemoveRef.name
    });
    addedFiles.splice(targetFileIndex, 1);

    //you can't filter an object
    // let newFileList = fileList.filter(file => file !== itemToRemoveRef);
    $item.closest('.js-file-upload__item').remove();

    if(newFileList.length <= 0){
        $dropArea.find('.js-file-upload__submit').prop('disabled', true);
    }
    return newFileList;
}

function renderFileItem(name) {
    return `<span class="file-upload__item file-upload__item--text js-file-upload__item" data-file-name="${name}">
                <span class="row row-gutter--2 align-items-center">
                    <span class="col-10">
                       ${name}
                    </span>
                    <span class="col-2">
                        <button type="button" class="js-file-upload__remove-item btn-no-styling file-upload__remove text-danger ml-1 p-2">
                            <span class="icon icon-close" aria-label="remove item" title="remove item"></span>
                        </button>
                    </span>
                </span>
            </span>`;
}

function renderImageFileItem(name, src) {
    return `<span class="file-upload__item file-upload__item--img js-file-upload__item" data-file-name="${name}">
                <img src="${src}" alt="${name}">
                <button type="button" class="js-file-upload__remove-item btn-no-styling file-upload__remove text-danger ml-1 p-2">
                    <span class="icon icon-close" aria-label="remove item" title="remove item"></span>
                </button>
            </span>`;
}

function updateFileResult($this, $input, $newItem, file, $fileResult, fileList, initialMaxFileNumber, $submitBtn, $dropArea, $error, addedFiles){
    $fileResult.append($newItem);
    // is needed to remove exactly this file
    $newItem.data('file', file);
    $input.data('filelist', fileList);
    $this.data('parsley-max-file-upload', initialMaxFileNumber - $input[0].files.length );
    $this.data('parsley-file-length', fileList.length );

    if(fileList.length > 0){
        $submitBtn.prop('disabled', false);
        $dropArea.removeClass('file-drop-area--error');
    }

    initModulesInScope($newItem);

    $input.parsley().validate();

    let $removeItem = $fileResult.find('.js-file-upload__remove-item');
    $removeItem.on('click', function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        let newFileList = removeItem($(this), fileList, $error, $dropArea, addedFiles)
        let dt = new DataTransfer();
        newFileList.forEach(function(newFile) {
            dt.items.add(newFile);
        })
        $input[0].files = dt.files;
        $input.data('filelist', dt.files);
        $this.data('parsley-max-file-upload', initialMaxFileNumber - $input.data('filelist').length );
        $this.data('parsley-file-length', $input.data('filelist').length );
        $this.parsley().validate();
        $this.trigger('input-file-remove');
        $error.attr("hidden",true);
        $dropArea.removeClass('file-drop-area--error');
    });
}

export function updateFileUpload($input, fileList, $fileResult, $error, $submitBtn, $dropArea, initialMaxFileNumber, $form, addedFiles) {
    let successState = false;
    let $this = $input;
    let $newItem;
    let maxFileNumber = +$this.data('parsley-max-file-upload');
    let validFile = null;

    // save the fileList in the form-dataset, to avoid referencing problems with removing and adding
    if (!$input.data('filelist')) {
        $input.data('filelist', []);
    }

    $fileResult.empty();
    Array.from(fileList).forEach(file => {
        if(fileList.length <= maxFileNumber) {

            let acceptedType = $input.attr('accept');
            var callbacks = $.Callbacks();
            // easy check - if more/other types are accepted this probably needs to be improved
            if (acceptedType && acceptedType !== '*') {
                validFile = function () {
                    for(let i = 0; i < fileList.length; i++){
                        if (acceptedType.indexOf(fileList[i].type) >= 0) {
                            return true;
                        }else{
                            return false;
                        }
                    }
                }();

                if (validFile){
                    $error.attr('hidden', true);

                    if (file.type.indexOf('image') >= 0) {
                        let reader = new FileReader();
                        reader.onload = function(e) {
                            successState = true;

                            let src = e.target.result;
                            $newItem = $(renderImageFileItem(file.name,src));

                            updateFileResult($this, $input, $newItem, file, $fileResult, fileList, initialMaxFileNumber, $submitBtn, $dropArea, $error, addedFiles);

                        };

                        reader.readAsDataURL(file);
                    }else{
                        successState = true;

                        $newItem = $(renderFileItem(file.name));
                        updateFileResult($this, $input, $newItem, file, $fileResult, fileList, initialMaxFileNumber, $submitBtn, $dropArea, $error, addedFiles);
                    }




                }else{
                    $error.empty().text(translate('file-upload.error.message.notValid'));
                    $error.attr("hidden",false);
                    $dropArea.addClass('file-drop-area--error');
                }
            }


        }else{
            $error.empty().text(translate('file-upload.error.message.maxFiles'));
            $error.attr("hidden",false);
            $dropArea.addClass('file-drop-area--error');
        }
    });


    return successState;
}

function getUpdatedFileList(targetList, sourceList) {
    for (let i = 0; i < sourceList.length; i++) {
        let targetFileIndex = targetList.findIndex(function (file) {
            return file.name === sourceList[i].name
        });
        if (targetFileIndex === -1) {
            targetList.push(sourceList[i]);
        } else {
            targetList[targetFileIndex] = sourceList[i];
        }
    }

    let dt = new DataTransfer();
    targetList.forEach(function(file) {
        dt.items.add(file);
    });

    return dt.files
}